var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditIcon = function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.374 3.045-1.92-1.92a.997.997 0 0 0-1.414 0L6.667 3.5h-6A.666.666 0 0 0 0 4.166v8.667c0 .369.299.667.667.667h8.666a.666.666 0 0 0 .667-.667v-6l2.374-2.374a.997.997 0 0 0 0-1.414ZM5.667 9.281 4.219 7.833l4.195-4.195 1.448 1.448L5.667 9.28Zm-1.708-.893L5.13 9.54 4 9.5l-.04-1.112Zm4.708 3.778H1.333V4.833h4l-2.12 2.12c-.195.195-.318.541-.419.86-.107.333-.127.703-.127.98v2.04h2.04c.276 0 .739-.067 1.048-.193.309-.127.597-.232.792-.427l2.12-2.047v4Zm1.666-7.552L8.885 3.166l.862-.862 1.448 1.448-.862.862Z",
    fill: "#C8CDC5"
  })));
};
export default SvgEditIcon;